import {createSlice} from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "owners",
  initialState: {
    offsets: {},
  },

  reducers: {
    setOwnerData: (state, {payload: offsets}) => {
      return {
        ...state,
        offsets,
      };
    },
  },
});

export const {setOwnerData} = slice.actions;
export default slice.reducer;

export const getOwnersSelector = (store) => store.owners.offsets;
